import { createSlice } from "@reduxjs/toolkit";
import { getProductList } from "../Actions/getProductList";

export const productListReducer = createSlice({
    name: "productListReducer",
    initialState: {
        isLoading: false,
        data: null,
        isError: false,
    },
    reducers: {
        resetProductList: (state, action) => {
            state.data = undefined
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getProductList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getProductList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getProductList.rejected, (state, action) => {
            console.error("Error", action.payload);
            state.isError = true;
            state.isLoading = false;
        });
    },
});

export const { resetProductList } = productListReducer.actions;